import { RoadmapItem } from '../../features/updates/types';
import { api } from '../slices/api';

export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		getRoadmapItems: builder.query<RoadmapItem[], void>({
			query: () => 'roadmap-items/',
		}),
	}),
});

export const { useGetRoadmapItemsQuery } = extendedApiSlice;
